const note = {
    version: '1.1.0',
    date: '2026-09-07',
    tags: ['Forbedret'],
    body: `
- **En Outlook sync åbner med Send to CapLegal with delay sat.** Feltet er slået til på forhånd, når du konverterer den til en timelog.
- **Du kan nå at rette.** Din timelog bliver derfor i kalenderen nogle timer endnu, før den sendes til CapLegal.
`,
};

export default note;
